import styled from 'styled-components';

import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';

export default styled.div`
	margin-bottom: 10px;
	padding: 10px;
	background: rgba(${(props) => toRgbString(props.theme.colors.yellow)}, 0.25);
	color: ${(props) => props.theme.colors.yellow};
	border-radius: 5px;
`;
